import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../ui/accordion";
import { FAQS } from "../../data/content";

const Overline = ({ children, num }) => (
  <div className="flex items-center gap-4 mb-5">
    <span className="font-mono text-xs uppercase tracking-[0.25em] text-neutral-500">{num}</span>
    <span className="h-px w-10 bg-white/20" />
    <span className="font-mono text-xs uppercase tracking-[0.25em] text-neutral-400">{children}</span>
  </div>
);

export const Faq = () => {
  return (
    <section id="contracting" data-testid="faq-section" className="relative border-t border-white/10 bg-[#0A0A0A] scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-4">
            <Overline num="05">Contracting Information</Overline>
            <h2 className="font-sans font-black uppercase tracking-tight text-4xl md:text-5xl text-white leading-[0.95]">
              How To Buy <span className="metal-text">From Atlas</span>
            </h2>
            <p className="mt-6 font-body text-neutral-400 text-base leading-relaxed">
              Straight answers for contracting officers and prime partners. Don't see your question? Reach out and we'll respond directly.
            </p>
          </div>

          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`faq-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-white/10"
                >
                  <AccordionTrigger className="font-sans font-semibold uppercase tracking-tight text-lg md:text-xl text-white py-6 hover:no-underline">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="font-body text-neutral-400 text-sm md:text-base leading-relaxed pb-6 pr-6">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};
